/**
 * Startle / initiative delay (E05).
 *
 * On the first transition into `COMBAT`, an enemy incurs a brief pause
 * before its first action fires. Per the enemies-and-ai spec:
 *
 *   - First contact (never detected by this enemy before): 2–3s
 *   - Re-engaged (detected previously, lost target, re-detected): 1–2s
 *
 * Pure resolver: `rand` is a `() => number` in [0, 1) so tests can feed a
 * deterministic stream. The runtime wires `Math.random` (routed via the
 * shared RNG entry point in `engine/combat/dice.ts`).
 */

export interface StartleTimerInput {
  readonly firstContact: boolean;
  readonly rand: () => number;
}

export const STARTLE_FIRST_CONTACT_MIN = 2.0;
export const STARTLE_FIRST_CONTACT_MAX = 3.0;
export const STARTLE_REENGAGE_MIN = 1.0;
export const STARTLE_REENGAGE_MAX = 2.0;

export function startleTimerSeconds(input: StartleTimerInput): number {
  const min = input.firstContact ? STARTLE_FIRST_CONTACT_MIN : STARTLE_REENGAGE_MIN;
  const max = input.firstContact ? STARTLE_FIRST_CONTACT_MAX : STARTLE_REENGAGE_MAX;
  const t = Math.min(0.9999999, Math.max(0, input.rand()));
  return min + (max - min) * t;
}
